<template>
  <div class="elementor-element elementor-element-698d3ae2 e-flex e-con-boxed e-con e-parent" data-id="698d3ae2"
    data-element_type="container"
    data-settings="{&quot;background_background&quot;:&quot;gradient&quot;,&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}"
    data-core-v316-plus="true">
    <div class="e-con-inner">
      <div class="elementor-element elementor-element-72e2eb68 e-con-full e-flex e-con e-child"
        data-id="72e2eb68" data-element_type="container"
        data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;container_type&quot;:&quot;flex&quot;}">
        <div class="elementor-element elementor-element-5cefe36e elementor-widget elementor-widget-heading"
          data-id="5cefe36e" data-element_type="widget" data-widget_type="heading.default">
          <div class="elementor-widget-container">
            <h2 class="elementor-heading-title elementor-size-default">Trade CFDs With Socrates Confidence</h2>
          </div>
        </div>
        <div
          class="elementor-element elementor-element-1dff7f20 elementor-tablet-align-left elementor-mobile-align-center elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
          data-id="1dff7f20" data-element_type="widget" data-widget_type="icon-list.default">
          <div class="elementor-widget-container">
            <ul class="elementor-icon-list-items">
              <li class="elementor-icon-list-item">
                <span class="elementor-icon-list-icon">
                <svg aria-hidden="true" class="e-font-icon-svg e-fas-check" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>
                </span>
                <span class="elementor-icon-list-text">100% Full STP Broker</span>
              </li>
              <li class="elementor-icon-list-item">
                <span class="elementor-icon-list-icon">
                 <svg aria-hidden="true" class="e-font-icon-svg e-fas-check" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>
                </span>
                <span class="elementor-icon-list-text">100% Trade directly to Liquidity Provider</span>
              </li>
              <li class="elementor-icon-list-item">
                <span class="elementor-icon-list-icon">
                  <svg aria-hidden="true" class="e-font-icon-svg e-fas-check" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>
                </span>
                <span class="elementor-icon-list-text">Fully Licensed and Regulated</span>
              </li>
              <li class="elementor-icon-list-item">
                <span class="elementor-icon-list-icon">
                 <svg aria-hidden="true" class="e-font-icon-svg e-fas-check" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>
                </span>
                <span class="elementor-icon-list-text">Easy Deposit and Withdrawal</span>
              </li>
<!--               HIDE PAMM
              <li class="elementor-icon-list-item">
                <span class="elementor-icon-list-icon">
                  <svg width="512" height="512" class="e-font-icon-svg e-fas-check" aria-hidden="true">
                    <use href="/assets/svg/sprite.svg#icon_512x512_4"></use>
                  </svg>
                </span>
                <span class="elementor-icon-list-text">PAMM Account (Automated Trading)</span>
              </li> -->
              <li class="elementor-icon-list-item">
                <span class="elementor-icon-list-icon">
                 <svg aria-hidden="true" class="e-font-icon-svg e-fas-check" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>
                </span>
                <span class="elementor-icon-list-text">Copytrade with Reliable Partner</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="elementor-element elementor-element-60ad69cd e-flex e-con-boxed e-con e-child"
          data-id="60ad69cd" data-element_type="container"
          data-settings="{&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}">
          <div class="e-con-inner">
            <div class="elementor-element elementor-element-1d70b02e elementor-widget elementor-widget-button"
              data-id="1d70b02e" data-element_type="widget" data-widget_type="button.default">
              <div class="elementor-widget-container">
                <div class="elementor-button-wrapper">
                  <router-link class="elementor-button elementor-button-link elementor-size-sm"
                    to="/signup">
                    <span class="elementor-button-content-wrapper">
                      <span class="elementor-button-text">Create Account</span>
                    </span>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="elementor-element elementor-element-6858066f elementor-widget elementor-widget-button"
              data-id="6858066f" data-element_type="widget" data-widget_type="button.default">
              <div class="elementor-widget-container">
                <div class="elementor-button-wrapper">
                  <router-link class="elementor-button elementor-button-link elementor-size-sm"
                    to="/signup">
                    <span class="elementor-button-content-wrapper">
                      <span class="elementor-button-text">Try Demo Account</span>
                    </span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="elementor-element elementor-element-41e77d1f e-con-full e-flex e-con e-child"
        data-id="41e77d1f" data-element_type="container"
        data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;container_type&quot;:&quot;flex&quot;}">
        <div class="elementor-element elementor-element-5106e840 elementor-widget elementor-widget-image"
          data-id="5106e840" data-element_type="widget" data-widget_type="image.default">
          <div class="elementor-widget-container">
            <img decoding="async" width="1024" height="1024"
              src="/wp-content/uploads/2024/02/socrates-home-1024x1024.png"
              class="attachment-large size-large wp-image-688" alt=""
              srcset="/wp-content/uploads/2024/02/socrates-home-1024x1024.png 1024w, /wp-content/uploads/2024/02/socrates-home-300x300.png 300w, /wp-content/uploads/2024/02/socrates-home-150x150.png 150w, /wp-content/uploads/2024/02/socrates-home-768x768.png 768w, /wp-content/uploads/2024/02/socrates-home.png 1080w"
              sizes="(max-width: 1024px) 100vw, 1024px" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandingHero'
}
</script>

<style>
/* Elementor heading styles */
.elementor-heading-title {
  padding: 0;
  margin: 0;
  line-height: 1
}

.elementor-widget-heading .elementor-heading-title[class*=elementor-size-]>a {
  color: inherit;
  font-size: inherit;
  line-height: inherit
}

.elementor-widget-heading .elementor-heading-title.elementor-size-small {
  font-size: 15px
}

.elementor-widget-heading .elementor-heading-title.elementor-size-medium {
  font-size: 19px
}

.elementor-widget-heading .elementor-heading-title.elementor-size-large {
  font-size: 29px
}

.elementor-widget-heading .elementor-heading-title.elementor-size-xl {
  font-size: 39px
}

.elementor-widget-heading .elementor-heading-title.elementor-size-xxl {
  font-size: 59px
}

/* Elementor image styles */
.elementor-widget-image {
  text-align: center
}

.elementor-widget-image a {
  display: inline-block
}

.elementor-widget-image a img[src$=".svg"] {
  width: 48px
}

.elementor-widget-image img {
  vertical-align: middle;
  display: inline-block
}
</style>